export default {
  development: {
    api: {
      url: 'http://localhost:8081/data/'
    }
  },
  production: {
    api: {
      url: 'data/'
    }
  }
}
